/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {KTableHeader, KTableSelectionCellNonMultiple} from '../../../../../../components/UI'
import {useEffect, useMemo, useState} from 'react'
import {LaundryBatchModel, SelectModel} from '../../../../model'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {TabLavanderiaModel} from '../../../../../../models'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {useKTable} from '../../../../../../contexts/KTableProvider'
import useTableForMaster from '../../../../hooks/useTableForMaster'
import {useLaundryFilter} from '../../../../hooks/useLaundryFilter'
import {useCamp, useClient, useCompany, useSite} from '../../../../../central/hooks'
import {FormattedDate, getFormatDate} from '../../../../../../util/functions'
const ColumnTable = () => {
  const {currentTabItem, changeCurrentTabItem} = useLavanderia()
  const {selectedOn, data} = useKTable()
  const {
    typeProcessLaundry,
    getTypeProcessLaundryList,
    typeAdmin,
    getTypeAdminList,
    statusLaundryLot,
    getStatusLaundryLotList,
  } = useTableForMaster()
  const {laundryPointByOrder, getLaundryPointByOrderList} = useLaundryFilter()
  const [company, setCompany] = useState<SelectModel[]>([])
  const [clients, setClients] = useState<SelectModel[] | any>([])
  const [sites, setSites] = useState<SelectModel[] | any>([])
  const [camps, setCamps] = useState<SelectModel[]>([])
  const {getCompanyFD} = useCompany()
  const {getClientFD} = useClient()
  const {getSiteFD} = useSite()
  const {getCampFD} = useCamp()

  useEffect(() => {
    getTypeProcessLaundryList()
    getTypeAdminList()
    getLaundryPointByOrderList()
    getCompanyList()
    getClientList()
    getSiteList()
    getCampList()
    getStatusLaundryLotList()
  }, [])

  const getCompanyList = async () => {
    const response = await getCompanyFD({})
    setCompany(response)
  }
  const getClientList = async () => {
    const response = await getClientFD({})
    setClients(response)
  }
  const getSiteList = async () => {
    const response = await getSiteFD({})
    setSites(response)
  }
  const getCampList = async () => {
    const response = await getCampFD({})
    setCamps(response)
  }

  const handleViewPanel = (data: any) => {
    const getRow = data.row
    const getArrows = data.data
    const getData = getArrows[getRow.index]
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      showPanel: true,
      idToEdit: getData.id,
      typeProcess: getData.tipoProceso,
      lugarLavado: getData.lugarLavado,
      content: {
        ...currentTabItem.content,
        detailPanel: 'tab-laundry-batch',
      },
      idToDelete: '',
    }
    changeCurrentTabItem(obj)
  }

  const handleGetId = (id: any) => {
    const getRow = data.filter((item) => item.id === id)
    if (getRow.length > 0) {
      let isLaundryStart = getRow[0].iniciarLavado ? false : true
      let isLaundryFinish = getRow[0].iniciarLavado ? true : false
      let isExist = currentTabItem.detailRow ? true : false
      const updatedTabItem =
        isExist && currentTabItem.detailRow.id === id
          ? {
              ...currentTabItem,
              typeAdmin: '',
              typeProcess: '',
              isStartLaundry: false,
              isFinishOut: false,
              isFinishLaundry: false,
              isCancel: false,
              detailRow: null,
            }
          : {
              ...currentTabItem,
              typeAdmin: getRow[0].tipoAdministracion,
              typeProcess: getRow[0].tipoProceso,
              isStartLaundry: isLaundryStart,
              isFinishOut: getRow[0].finalizarSalidad,
              isFinishLaundry: isLaundryFinish,
              isCancel: getRow[0].estado === 'OLG',
              detailRow: getRow[0],
            }
      changeCurrentTabItem(updatedTabItem)
    }
  }

  const columns: Column<LaundryBatchModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} />,
        id: 'selection',
        Cell: ({...props}) => (
          <KTableSelectionCellNonMultiple
            id={props.data[props.row.index].id}
            clickHandler={handleGetId}
            disable={
              props.row.original.estadoNombre === 'FINALIZADO' ||
              props.row.original.estadoNombre === 'CANCELADO'
            }
          />
        ),
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions',
        Cell: ({...props}) => (
          <div className='d-flex'>
            <div
              className='d-flex justify-content-center flex-shrink-0'
              onClick={() => handleViewPanel(props)}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen004.svg' className='svg-icon-3' />
              </a>
            </div>
          </div>
        ),
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de Proceso'
            name='tipoProceso'
            data={typeProcessLaundry}
            selecteable
          />
        ),
        accessor: 'tipoProceso',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Nro Lote' searcheable name='nroOrdenLote' />
        ),
        accessor: 'nroOrdenLote',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Ordenes de Lavado' name='cantidadOrdenLavado' />
        ),
        accessor: 'cantidadOrdenLavado',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Fecha creación' name='fechaRegistro' dateable />
        ),
        accessor: 'fechaRegistro',
        Cell: ({...props}) => {
          let dateCreation = props.data[props.row.index].fechaRegistro
            ? getFormatDate(props.data[props.row.index].fechaRegistro)
            : ''
          return <span>{dateCreation ? `${(dateCreation as FormattedDate).fecha}` : ''}</span>
        },
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de lavado'
            name='tipoAdministracion'
            selecteable
            data={typeAdmin}
          />
        ),
        accessor: 'tipoAdministracion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Punto de Lavanderia'
            data={laundryPointByOrder}
            name='puntoId'
            selecteable
          />
        ),
        accessor: 'punto',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cantidad total de prendas'
            name='cantidadTotal'
            searcheable
            number
          />
        ),
        accessor: 'cantidadTotal',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Total KG' name='pesoTotal' searcheable number />
        ),
        accessor: 'pesoTotal',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Estado'
            name='estadoNombre'
            selecteable
            data={statusLaundryLot}
          />
        ),
        accessor: 'estadoNombre',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Compañia'
            name='companiaId'
            selecteable
            data={company}
          />
        ),
        accessor: 'nombreCompania',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cliente'
            name='clienteId'
            selecteable
            data={clients}
          />
        ),
        accessor: 'nombreCliente',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Site' name='siteId' selecteable data={sites} />
        ),
        accessor: 'nombreSite',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Campamento'
            name='campamentoId'
            selecteable
            data={camps}
          />
        ),
        accessor: 'nombreCampamento',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions_ver',
        Cell: ({...props}) => (
          <div className='d-flex'>
            <div
              className='d-flex justify-content-center flex-shrink-0'
              onClick={() => handleViewPanel(props)}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen004.svg' className='svg-icon-3' />
              </a>
            </div>
          </div>
        ),
      },
    ],
    [
      data,
      selectedOn,
      typeProcessLaundry,
      typeAdmin,
      laundryPointByOrder,
      camps,
      sites,
      company,
      clients,
      statusLaundryLot,
    ],
  )

  return {columns}
}

export {ColumnTable}
